module.exports = __webpack_public_path__ + "static/media/app2.85d0aaea.png";